
import {Component, Vue} from 'vue-property-decorator';
import {readAdminRoles, readDefaultRoleSettings} from '@/store/admin/getters';

@Component({})
export default class ImportRoleSettings extends Vue {
  private dialog: boolean = false;
  // private importDefault: boolean = false;
  private selectedRole: any = null;

  public importFunction(val) {
    // if (this.importDefault) {
    //   console.log(this.defaultSettings)
    //   this.$emit('import-function', this.defaultSettings);
    // } else
    if (!this.selectedRole) {
      return;
    }
    this.dialog = false;
    this.$emit('import-function', val);
  }

  // @Watch('importDefault')
  // private changeImportDefault(val, oldVal) {
  //   if (this.importDefault) {
  //     this.selectedRole = null;
  //   }
  // }

  private get roles() {
    return readAdminRoles(this.$store);
  }

  private get defaultSettings() {
    return readDefaultRoleSettings(this.$store);
  }


}
